export var GatewayURL = ""
export const APIBaseURL = window.origin == "https://localhost:44466" ? process.env.REACT_APP_API_URL : window.origin + "/api/"
export const AuthBaseURL = "api/v1/aut/"
export const TaskURL = "api/v1/wfp/"
export const CrudURL = "api/v1/dcr/"
export const AttachURL = "api/v1/att/"
export const SupportURL = "api/v1/sup/"
export const DataAsServiceURL = "api/v1/das/"
export const DocumentURL = "api/v1/doc/"
export const BIMURL = "api/v1/bim/"
export const ZATURL = "api/v1/zat/"
export const LinkURL = "https://oplink.oreapps.com/api/"
export const CDNPath = "https://cdn2.sterloapp.com/cdncontainers"
export const SessionURL = "https://crghub.aaagroup.com/opnot/api/v1/session/"
export const LogURL = "api/v1/opl/"
export const SterloLogURL = "api/v1/log/"